export enum TwoFactorAuthSteps {
  PHONE_INPUT = 'phoneInput',
  CODE_VERIFICATION = 'codeVerification',
  SUCCESS = 'success',
}
